function validaCpfCnpj(val) {
    if (!val) return false;

    const cleaned = val.replace(/\D/g, '');

    if (cleaned.length === 11) return validaCpf(cleaned);
    if (cleaned.length === 14) return validaCnpj(cleaned);

    return false;
}

function validaCpf(cpf) {
    if (cpf.split('').every(d => d === cpf[0])) return false;

    const digits = cpf.split('').map(Number);
    let v1 = 0, v2 = 0;

    for (let i = 0; i < 9; i++) {
        v1 += digits[i] * (10 - i);
        v2 += digits[i] * (11 - i);
    }

    v1 = (v1 * 10) % 11;
    if (v1 === 10) v1 = 0;
    if (v1 !== digits[9]) return false;

    v2 += v1 * 2;
    v2 = (v2 * 10) % 11;
    if (v2 === 10) v2 = 0;
    if (v2 !== digits[10]) return false;

    return true;
}

function validaCnpj(cnpj) {
    if (cnpj.split('').every(d => d === cnpj[0])) return false;

    const digits = cnpj.split('').map(Number);
    let v1 = 0, v2 = 0;
    const multiplicadores1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const multiplicadores2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    for (let i = 0; i < 12; i++) {
        v1 += digits[i] * multiplicadores1[i];
        v2 += digits[i] * multiplicadores2[i];
    }

    v1 = v1 % 11;
    v1 = v1 < 2 ? 0 : 11 - v1;
    if (v1 !== digits[12]) return false;

    v2 += v1 * multiplicadores2[12];
    v2 = v2 % 11;
    v2 = v2 < 2 ? 0 : 11 - v2;
    if (v2 !== digits[13]) return false;

    return true;
}

export default validaCpfCnpj;